export default __webpack_public_path__ + "aa81ee2f0e3591a093f682f4bfc147cc.jpg";